import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/** A page's search box that starts with, and follows, the ?search= text of the link that opened it (as the global search does) */
export function useUrlSearch(): [string, (value: string) => void] {
  const [params] = useSearchParams();
  const [value, setValue] = useState(params.get("search") || "");
  useEffect(() => setValue(params.get("search") || ""), [params]);
  return [value, setValue];
}
